<div class="hexagon me-3">
  <div [style]="{ 'background-image': 'url(' + iconUrl + ')' }"></div>
</div>
